import React from 'react';
import { Send } from 'lucide-react';

export function ChatInput({ value, onChange, onSend, disabled, onKeyPress }) {
  return (
    <div className="fixed bottom-20 left-0 right-0 px-4 pb-4 bg-background border-t border-border">
      <div className="max-w-2xl mx-auto flex gap-2">
        <input
          type="text"
          value={value}
          onChange={onChange}
          onKeyPress={onKeyPress}
          placeholder="Ask me anything..."
          disabled={disabled}
          className="flex-1 px-4 py-3 bg-surface border border-border rounded-lg text-foreground placeholder-text-muted focus:outline-none focus:ring-2 focus:ring-primary disabled:opacity-50"
          data-testid="chat-input"
        />
        <button
          onClick={onSend}
          disabled={!value.trim() || disabled}
          className="px-4 py-3 bg-primary text-white rounded-lg hover:bg-primary/90 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          data-testid="send-message-btn"
        >
          <Send className="w-5 h-5" />
        </button>
      </div>
    </div>
  );
}
